/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSignalH = createReactComponent("outline", "signal-h", "IconSignalH", [["path", { "d": "M10 16v-8", "key": "svg-0" }], ["path", { "d": "M14 8v8", "key": "svg-1" }], ["path", { "d": "M10 12h4", "key": "svg-2" }]]);

export { IconSignalH as default };
//# sourceMappingURL=IconSignalH.mjs.map
